import { makeStyles, createStyles } from '@material-ui/core/styles';

import fonts from 'styles/fonts';
import spacings from 'styles/spacing';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '& .MuiAutocomplete-endAdornment': {
        display: 'none',
      },
      '& *::placeholder': {
        opacity: 1,
      },
      '& .MuiInputBase-root': {
        padding: '0px 9px !important',
        height: 'auto',
        minHeight: 59,
      },
    },
    hasItemSelected: {
      '& .MuiInputBase-root': {
        padding: '9px 9px !important',
        overflow: 'hidden',
      },
    },
    option: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: 56,
      width: '100%',
      padding: `${spacings.xxxsmall} ${spacings.xsmall}`,
      '& > span': {
        fontSize: fonts.sizes.xxsmall,
        lineHeight: '16px',
      },
      '& > p': {
        maxWidth: 'calc(100% - 10px)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
  }),
);

export default useStyles;
